export default "<p>\n  action-modal works!\n</p>\n";